var Raphael = require('raphael');
var LineResizeMixin = require('./line');

/*
* Same as line, except for some hacks in place to deal
* with bugs working with the arrow marker in Raphael.
* */


module.exports = {

    resizeStart: function() {

        if ( !LineResizeMixin.resizeStart.apply( this, arguments ) )
            return false;

        /*
         * Hack work-around for Raphael issue with arrows.
         * Still needed -- without -- will get the error on move (this sets up that hack).
         * Could use clearer organization.
         * */
        var path = Raphael.parsePathString( this.el.attr('path') ); // if parse on move will get error on drag

        this.oPt = {
            x: path[0][1],
            y: path[0][2]
        };

        this.oArrow = this.el.attr('arrow-end');

        return true;

    },

    resizeMove: LineResizeMixin.resizeMove,

    resizeEnd: function() {

        if ( !LineResizeMixin.resizeEnd.apply( this, arguments ) )
            return false;

        delete this.oPt;
        delete this.oArrow;

        return true;

    },

    updateDragPtHandleAndPathOnMove: LineResizeMixin.updateDragPtHandleAndPathOnMove,

    /* This still appears to be needed
     * When line is small you'll get errors in Raphael when applying the arrow.
     * TODO -- this can still break ...
     *  try rapid resizing around the origin... (esp at larger sizes)
     *  -- maybe make a fn of the arrow size ???
     *  maybe store the limit on the arrow shape view or model when create it???
     */
    updatePath: function(e) {

        var LIM = 10; // check if within 10 from the origin -- the other pt -- Raphael hack
        var mousePos = this.parent.getMousePos(e);

        // 1) hack to prevent 'size error'
        if ( (Math.abs(this.oPt.x - mousePos.x) < LIM) || ( Math.abs(this.oPt.y - mousePos.y) < LIM ) )
            return;

        //2) other hack: remove the attr then add it after the path to allow the arrow to move when the path moves in IE10
        this.el
            .attr('arrow-end', '')
            .setPathFromPtsArray( this.currentPts )
            .attr( 'arrow-end', this.oArrow );

    }

};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/resizeFns/poly/lineArrow.js
 ** module id = 204
 ** module chunks = 0
 **/